import React, { useCallback, useState } from 'react';
import { useDispatch } from "react-redux";
import { filterBySearch } from '../redux/filtersBlogs/actions';

const SearchBar = () => {
    const [search, setSearch] = useState('')
    const dispatch = useDispatch()

    const debounce = (func) => {
        let timer;
        return function (...argu) {
            const context = this;
            if (timer) clearTimeout(timer)
            timer = setTimeout(() => {
                timer = null
                func.apply(context, argu)
            }, 500)
        }
    }

    const HandleSearch = (event) => {
        const { value } = event.target;
        dispatch(filterBySearch(value))
    }

    //useCallback provides us the memoizd callback

    const optimizedVersion =useCallback(debounce(HandleSearch),[])

    return (
        <>
            <div
                class="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200"
            >
                <input
                    class="outline-none border-none bg-gray-50 h-full w-full mr-2"
                    type="search"
                    name="search"
                    placeholder="Search"
                    onChange={optimizedVersion}
                />
                <img
                    class="inline h-6 cursor-pointer"
                    src="./assets/search.svg"
                    alt="Search"
                />
            </div>
        </>
    );
};

export default SearchBar;